
export default {
  edit: {

  },
  list: {

  },
};
